import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  pure:false
})
export class FilterByPipe implements PipeTransform {

  //items : list, filter : key-value pair of filter
  transform(items: Array<any>, filter: {[key: string]: any }): any {
    if (!items || !filter) {
      return items;
    }
    
    return items.filter(item => {
      let notMatchingField = Object.keys(filter).find(key => item[key] !== filter[key]);

      return !notMatchingField; // true if matches all fields
    });
  }

}
